// import ImageSlider from './ImageSlider'; 


// import ComputerScineceLab1 from '../assets/images/facilities/ComputerScineceLab-1.jpg';
// import ComputerScineceLab2 from '../assets/images/facilities/ComputerScineceLab-2.jpg';


// const images = [
//     { src: ComputerScineceLab1, altText: 'Psychology Lab-1' },
//     { src: ComputerScineceLab2, altText: 'Psychology Lab-2' },
  
// ];
const ComputerLab = () => {
    return (
        <section className="ftco-section ftco-no-pt ftco-no-pb"> 
            <div className="container">
                <div className="row justify-content-center mt-3 pb-4">
                    <div className="col-md-12 heading-section ftco-animate text px-4">
                        <h2 className="mb-4 text-success text-center">
                            Computer Lab
                        </h2>   
                    </div>
                </div>
                
                <div className="row mt-3">
                    <div className="col-md-8 order-md-first wrap-about">
                        <div className="text px-4">
                            <p>
                            The Computer Science Lab at SRN is a state-of-the-art facility designed to provide students with hands-on experience in programming, software development, and digital literacy. The lab is equipped with the latest technology to enhance learning and prepare students for the digital era. </p>
                         </div>
                    </div>
                    {/* <div className=" col-md-4 order-md-first wrap-about">
                    <ImageSlider images={images} />              
                    </div>
                      */}
                </div>  
            </div>
            <hr className="custom-hr"/>
        </section>
    );
};

export default ComputerLab;
